import type { FeaturePreferenceKey } from "models/types/agency-settings";
import { useIsAgencyFeaturePreferenceEnabled } from "hooks/use-is-agency-feature-preference-enabled";

export type FeaturePreferencesConditionalComponent = {
  feature: FeaturePreferenceKey;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export function FeaturePreferencesConditionalComponent({
  feature,
  children,
  fallback = null,
}: FeaturePreferencesConditionalComponent) {
  const isAgencyFeaturePreferenceEnabled =
    useIsAgencyFeaturePreferenceEnabled();

  return <>{isAgencyFeaturePreferenceEnabled(feature) ? children : fallback}</>;
}
